import { render, staticRenderFns } from "./EditAlias.vue?vue&type=template&id=50d992ab"
import script from "./EditAlias.vue?vue&type=script&lang=js"
export * from "./EditAlias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports